let handleNotification;
const handlePermission =(callback)=>{
    handleNotification= callback
    if(window.safari && window.safari.pushNotification){
        let result = window.safari.pushNotification.permission("web.com.staffing.goagalia")
        checkPermission(result)   
    }
};


const checkPermission =(permissionData)=>{
    console.log(permissionData,"permission data")
    if(permissionData.permission==="default"){
        window.safari.pushNotification.requestPermission(process.env.REACT_APP_API_ENDPOINT.slice(0, -1),"web.com.staffing.goagalia",{panel:"staffing"},checkPermission)
    }
    else if(permissionData.permission==="denied"){
        console.log("denied")
    }
    else if (permissionData.permission==="granted"){
        console.log("granted")
        handleNotification(permissionData.deviceToken)
    }
}


export {handlePermission};